import Axios from 'axios';

import { Events } from '../../Events/ConsumerEvents/Events';
import GetOfferFormModal from '../../Components/LeadForms/GetOfferForm/GetOfferFormModal/GetOfferFormModal.vue';
import 'v-slick-carousel/style.css';
import { VSlickCarousel } from 'v-slick-carousel';
import { mapWritableState } from 'pinia';
import { useTextModalStore } from '../../store/Shared/TextModalStore/TextModalStore';

export default {
  data() {
    return {
      hideAuotmatedSpecials: window.hideAuotmatedSpecials,
      useoverrides: window.digiServiceUseOverrides,
      userPin: window.userpin,
      libraryImagePath: atob(window.libraryImagePath),
      slickOptions: {
        groupsToShow: 1,
        infinite: true,
        arrows: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              groupsToShow: 1,
              infinite: false,
              arrows: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              groupsToShow: 1,
              infinite: false,
              arrows: true,
            },
          },
        ],
      },
      special: '',
      disclaimer: '',
      baseUrl: window.baseUrl,
      GetOfferForm: false,
      offerid: '',
      styleid: '',
      vin: '',
      consumereventid: Events.eventsConstants.getOffer,
      coupons: '',
      offerdesignid: '0',
      openOffer: false,
      dealerurl: '',
      menuCount: document.getElementsByClassName('classic-menu-count')
        ? document.getElementsByClassName('classic-menu-count').length
        : 0,

      actualMenuCount: 7,
    };
  },
  computed: {
    ...mapWritableState(useTextModalStore, ['showTextModal', 'text', 'title']),
  },
  components: {
    GetOfferFormModal,
    VSlickCarousel,
  },
  mounted() {
    if (window.innerWidth <= 1800) {
      this.actualMenuCount = 5;
    }

    if (window.innerWidth <= 1800 && this.menuCount >= 7) {
      return;
    }

    if (window.userpin) {
      this.getUpgradeMatrix();
    } else {
      this.getSpecials();
    }

    if (this.menuCount < this.actualMenuCount) {
      this.getCoupons();
    }
  },
  methods: {
    getUpgradeMatrix() {
      Axios.get(
        `${window.ApiBaseUrl}/upgradematrix/get?accountId=${window.accountId}&pin=${window.userpin}`
      ).then((response) => {
        if (response.data) {
          this.special = response.data[0];
        }
      });
    },
    getSpecials() {
      Axios.get(
        `${window.ApiBaseUrl}/Offers/BannerOffers?Campaignid=${window.campaignId}&Make=${window.make}&IsContactUrlPassed=true`
      ).then((response) => {
        if (response?.data?.paymentOffers?.length) {
          this.special = response.data.paymentOffers[0];
        } else if (this.menuCount >= this.actualMenuCount) {
          this.getCoupons();
        } else {
          // No action needed for other cases
        }
      });
    },

    getCoupons() {
      let url = `${window.ApiBaseUrl}/Offers/servicecoupons?accountID=${window.accountId}&campaignID=${window.campaignId}`;

      if (window.userDetails.userpin) {
        url += '&userPin=' + window.userDetails.userpin;
      }
      Axios.get(url).then((response) => {
        this.coupons = response.data;
      });
    },

    onOpenDisclaimer(text) {
      this.text = text;
      this.title = 'Disclaimer';
      this.showTextModal = true;
    },

    openGetoffer(offerId, vin, styleId) {
      this.GetOfferForm = true;
      this.offerid = offerId;
      this.styleid = styleId;
      this.vin = vin;
      this.offerdesignid = '0';
    },

    onGetOfferClick(offerid, styleid, vin, dealerurl, offerdesignid) {
      //Log google bind event
      logGoogleBingEvent(
        'Coupon Specials Page',
        'Button_Click',
        'Get Coupon',
        1,
        'Get Coupon Click'
      );
      this.GetOfferForm = true;
      this.offerdesignid = offerdesignid;
      this.offerid = offerid;
      this.styleid = styleid;
      this.vin = vin;
      this.dealerurl = dealerurl;
      this.consumereventid = Events.eventsConstants.GotServiceCoupon; //Get service coupon consumer event
    },
  },
};
